import React from 'react';
import { Navigate } from 'react-router';
import { Box } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import axiosInstance from '../actions/AxiosInstance';
import api from '../actions/EndPoints';
import connectWithUserStore from '../reducers/connectWithUserStore';
import { log } from '../Utils';
import { Content } from '../components/shared/Content';
import { PsBeaconLoadingSpinner } from '../components/shared/BeaconRegister';

const ValidationError = connectWithUserStore(({ state }) => {
    const fromEmailInvitation = sessionStorage.getItem('emailInv');
    const { apiKey } = state;
    const [success, checkSuccess] = React.useState(false);
    const [errorEnrolled, checkEnrolled] = React.useState(false);
    const [errorService, serviceError] = React.useState(false);
    const [primaryLoggedIn, primaryCheck] = React.useState(false);
    const [inviteExpired, setInviteExpired] = React.useState(false);
    const [statusCode, setStatusCode] = React.useState('error');
    const [isInHousehold, setInHousehold] = React.useState(false);
    const errorEnrolledOnly = errorEnrolled && !errorService;
    const getEncodedUrlText =
        JSON.parse(sessionStorage.getItem('emailInv'))?.encodedUrlText ??
        state?.pendingInvite?.encodedUrlText;

    async function getInvite() {
        log(console.log('Retrieving Invite info'));

        await axiosInstance
            .post(
                api.emailInvitationAPI,
                {
                    encodedUrlText: getEncodedUrlText,
                },
                { headers: { apiKey } }
            )
            .catch((error) => {
                log(console.log(error.response ?? error));
                const responseErrorStatus = error?.response?.data?.httpStatusCode;
                const status =
                    responseErrorStatus === 401 || responseErrorStatus === 403
                        ? responseErrorStatus
                        : 'error';
                window.metricsData.error =
                    Content?.emailInvitationError[status]?.analyticsErrorName;
                setStatusCode(status);
                setInviteExpired(true);
            });
    }

    async function getInviteEntity() {
        await axiosInstance.post(
            api.emailInvitationEntityAPI,
            JSON.parse(sessionStorage.getItem('emailInv')),
            { headers: { apiKey } }
        );
    }

    if (
        (fromEmailInvitation !== null &&
            window.location.pathname.includes('/usis/advice/fps/invite')) ||
        state?.pendingInvite?.encodedUrlText
    ) {
        React.useEffect(() => {
            getInvite().then(() =>
                getInviteEntity()
                    .then((res) => {
                        log(console.log('res from emailInvitationEntityAPI', res));
                        checkSuccess(true);
                    })
                    .catch((error) => {
                        log(console.log('err from emailInvitationEntityAPI', error));
                        if (error?.response?.data?.serviceErrorCode === 28000) {
                            primaryCheck(true);
                        } else if (error?.response?.data?.httpStatusCode === 401) {
                            primaryCheck(false);
                            checkEnrolled(false);
                            serviceError(false);
                        } else if (error?.response?.data?.httpStatusCode === 403) {
                            primaryCheck(false);
                            checkEnrolled(true);
                            serviceError(false);
                        } else if (
                            error.response.data.serviceErrorCode === 32000 ||
                            error.response.data.serviceErrorCode === 33000
                        ) {
                            primaryCheck(false);
                            checkEnrolled(false);
                            serviceError(false);
                            setInHousehold(true);
                        } else {
                            primaryCheck(false);
                            checkEnrolled(false);
                            serviceError(true);
                        }
                    })
            );
        }, []);
    }

    if (!state?.activeInvite && (isInHousehold || state?.planningGroup !== null)) {
        sessionStorage.removeItem('emailInv');
        return <Navigate to="/" />;
    }
    if (inviteExpired && statusCode === 401 && !isInHousehold) {
        return <Navigate to="/invitation-expired" />;
    }
    if (inviteExpired && statusCode !== 401 && !isInHousehold) {
        return <Navigate to="/invitation-service-error" />;
    }
    if (success) {
        return <Navigate to="/pin-entry" />;
    }
    if (primaryLoggedIn) {
        return <Navigate to="/primaryloggedin" />;
    }
    if (errorEnrolledOnly) {
        return <Navigate to="/" />;
    }
    if (errorService && state?.activeInvite) {
        return <Navigate to="/invitation-service-error" />;
    }

    return (
        <Box sx={{ height: 600 }}>
            <Box
                sx={{
                    height: '100%',
                    width: '100%',
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                }}>
                <PsBeaconLoadingSpinner aria-label="loading-spinner" scale="maxi" />
            </Box>
        </Box>
    );
});

const CoClientValidationComponent = () => {
    return (
        <Box sx={{ backgroundColor: '#F4F5F6' }} id="find-me">
            <Box>
                <ValidationError />
            </Box>
        </Box>
    );
};

export default function CoClientValidationView() {
    return <CoClientValidationComponent />;
}
